module.exports = __webpack_public_path__ + "static/lt-9b9c1703d576cccc06241e68dcbadea6.jpg";